export const STATUS_MODES_ICONS = {
  MANUAL: 'status-manual',
  AUTO: 'status-auto',
  MANUAL_SMALL: 'status-manual-small',
  AUTO_SMALL: 'status-auto-small'
}
